import React, { useState } from 'react';
import pic1 from "../../Assests/Gallery/pic1.jpg"
import pic2 from "../../Assests/Gallery/pic2.jpg"
import pic3 from "../../Assests/Gallery/pic3.jpg"
import pic4 from "../../Assests/Gallery/pic4.jpg"
import pic5 from "../../Assests/Gallery/pic5.jpg"
import pic7 from "../../Assests/Gallery/pic7.jpg"
import pic8 from "../../Assests/Gallery/pic8.jpg"
import pic9 from "../../Assests/Gallery/pic9.jpg"
import pic10 from "../../Assests/Gallery/pic10.jpg"
import pic12 from "../../Assests/Gallery/pic2.jpg"
import pic13 from "../../Assests/Gallery/pic13.jpg"
import pic18 from "../../Assests/Gallery/pic18.jpg"
import pic19 from "../../Assests/Gallery/pic19.jpg"
import pic20 from "../../Assests/Gallery/pic20.jpg"
import team1 from "../../Assests/Gallery/team1.jpg"
import team2 from "../../Assests/Gallery/team2.jpg"
import team3 from "../../Assests/Gallery/team3.jpeg"
import team4 from "../../Assests/Gallery/team4.jpg"
import team5 from "../../Assests/Gallery/team5.jpeg"
import team6 from "../../Assests/Gallery/team6.jpeg"
import team7 from "../../Assests/Gallery/team7.jpg"
import team8 from "../../Assests/Gallery/team8.jpg"
import team9 from "../../Assests/Gallery/team9.jpg"
import team10 from "../../Assests/Gallery/team10.jpg"
import newPhoto1 from "../../Assests/Gallery/chilanka-gallery-photo-1.jpg"
import newPhoto2 from "../../Assests/Gallery/chilanka-gallery-photo-2.jpg"
import newPhoto3 from "../../Assests/Gallery/chilanka-gallery-photo-3.jpg"
import newPhoto4 from "../../Assests/Gallery/chilanka-gallery-photo-4.jpg"
import newPhoto5 from "../../Assests/Gallery/chilanka-gallery-photo-5.jpg"
import newPhoto6 from "../../Assests/Gallery/chilanka-gallery-photo-6.jpg"
import newPhoto7 from "../../Assests/Gallery/chilanka-gallery-photo-7.jpg"
import newPhoto8 from "../../Assests/Gallery/chilanka-gallery-photo-8.jpg"
import newPhoto9 from "../../Assests/Gallery/chilanka-gallery-photo-9.jpg"
import newPhoto10 from "../../Assests/Gallery/chilanka-gallery-photo-10.jpg"
import newPhoto11 from "../../Assests/Gallery/chilanka-gallery-photo-11.jpg"
import newPhoto12 from "../../Assests/Gallery/chilanka-gallery-photo-12.jpg"
import camp2024_1 from "../../Assests/SummerCamp/camp2024-1.jpg"
import camp2024_2 from "../../Assests/SummerCamp/camp2024-2.jpg"
import camp2024_3 from "../../Assests/SummerCamp/camp2024-3.jpg"
import camp2024_4 from "../../Assests/SummerCamp/camp2024-4.jpg"
import camp2024_5 from "../../Assests/SummerCamp/camp2024-5.jpg"
import camp2025_1 from "../../Assests/SummerCamp/camp2025-1.jpg"
import camp2025_2 from "../../Assests/SummerCamp/camp2025-2.jpg"
import camp2025_3 from "../../Assests/SummerCamp/camp2025-3.jpg"
import camp2025_4 from "../../Assests/SummerCamp/camp2025-4.jpg"
import camp2025_5 from "../../Assests/SummerCamp/camp2025-5.jpg"
import camp2025_6 from "../../Assests/SummerCamp/camp2025-6.jpg"
import camp2025_7 from "../../Assests/SummerCamp/camp2025-7.jpg"
import camp2025_8 from "../../Assests/SummerCamp/camp2025-8.jpg"
import camp2025_9 from "../../Assests/SummerCamp/camp2025-9.jpg"

import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const eventImages = [pic1, pic2, pic3, pic4, pic5, pic13, pic7, pic8, pic9, pic18, newPhoto1, newPhoto2, newPhoto3, newPhoto4];
const classImages = [pic10, pic9, pic8, pic12, pic19, pic5, pic4, pic3, pic20, pic13, newPhoto5, newPhoto6, newPhoto7, newPhoto8];
const teamImages  = [team6, team2, team3, team4, team5, team1, team7, team8, team9, team10, newPhoto9, newPhoto10, newPhoto11, newPhoto12];
const summerCampAlbums = [
  { year: '2026', images: [camp2025_1, camp2025_2, camp2025_3, camp2025_4, camp2025_5, camp2025_6, camp2025_7, camp2025_8, camp2025_9] },
  { year: '2024', images: [camp2024_1, camp2024_2, camp2024_3, camp2024_4, camp2024_5] },
];

function GalleryComponent() {
  const [activeTab, setActiveTab] = useState('Events');
  const [activeTab1, setActiveTab1] = useState("Album 1");
  const [lightbox, setLightbox] = useState({ open: false, images: [], index: 0 });

  const openLightbox = (images, index) => setLightbox({ open: true, images, index });
  const closeLightbox = () => setLightbox({ ...lightbox, open: false });
  const prevPhoto = () => setLightbox(lb => ({ ...lb, index: (lb.index - 1 + lb.images.length) % lb.images.length }));
  const nextPhoto = () => setLightbox(lb => ({ ...lb, index: (lb.index + 1) % lb.images.length }));

  const sliderSettings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
  };

  return (
    <div className='md:px-[192px] md:py-[120px] px-4 py-10'>

      {/* Lightbox */}
      {lightbox.open && (
        <div className='fixed inset-0 bg-black bg-opacity-90 z-50 flex items-center justify-center' onClick={closeLightbox}>
          <button className='absolute top-4 right-6 text-white text-4xl font-bold' onClick={closeLightbox}>✕</button>
          <button className='absolute left-4 text-white text-5xl font-bold px-4' onClick={(e) => { e.stopPropagation(); prevPhoto(); }}>‹</button>
          <img src={lightbox.images[lightbox.index]} alt="" className='max-h-[90vh] max-w-[90vw] object-contain rounded-lg shadow-2xl' onClick={(e) => e.stopPropagation()} />
          <button className='absolute right-4 text-white text-5xl font-bold px-4' onClick={(e) => { e.stopPropagation(); nextPhoto(); }}>›</button>
          <div className='absolute bottom-4 text-white text-sm opacity-70'>{lightbox.index + 1} / {lightbox.images.length}</div>
        </div>
      )}

<div className='text-center mb-12'>
  <p className='text-[13px] uppercase tracking-[5px] text-[#E40F94] font-semibold mb-3'>Explore Our World</p>
  <div className='flex items-center justify-center gap-4 mb-4'>
    <div className='w-14 h-[1px] bg-[#E40F94]'></div>
    <div className='w-2 h-2 bg-[#E40F94] rotate-45'></div>
    <div className='w-2 h-2 border border-[#E40F94] rotate-45'></div>
    <div className='w-2 h-2 bg-[#E40F94] rotate-45'></div>
    <div className='w-14 h-[1px] bg-[#E40F94]'></div>
  </div>
  <h1 className='font-bold md:text-[48px] text-[32px] leading-tight text-gray-900' style={{ fontFamily: 'Playfair Display, serif' }}>
    Our <span className='text-[#E40F94] italic'>Gallery</span>
  </h1>
  <p className='mt-4 md:text-[18px] text-[15px] text-gray-500'>"A Glimpse Into Our Dance Journey"</p>
  <div className='w-16 h-[3px] bg-[#E40F94] rounded-full mx-auto mt-6'></div>
</div>

      {/* Desktop Tabs */}
      <div className='md:flex justify-center md:mt-16 hidden md:block'>
        <div className={`px-6 py-2 cursor-pointer md:w-[264px] text-center ${activeTab === 'Events' ? 'border-b-2 border-pink-500 text-pink-500' : ''}`} onClick={() => setActiveTab('Events')}>Events</div>
        <div className={`px-6 py-2 cursor-pointer md:w-[264px] text-center ${activeTab === 'Classes' ? 'border-b-2 border-pink-500 text-pink-500' : ''}`} onClick={() => setActiveTab('Classes')}>Classes</div>
        <div className={`px-6 py-2 cursor-pointer md:w-[264px] text-center ${activeTab === 'Team' ? 'border-b-2 border-pink-500 text-pink-500' : ''}`} onClick={() => setActiveTab('Team')}>Team</div>
        <div className={`px-6 py-2 cursor-pointer md:w-[264px] text-center ${activeTab === 'Summer Camp' ? 'border-b-2 border-pink-500 text-pink-500' : ''}`} onClick={() => setActiveTab('Summer Camp')}>Summer Camp</div>
      </div>

      {/* Desktop Content */}
      <div className='mt-6 text-center hidden md:block max-w-[1100px] mx-auto'>

        {/* EVENTS */}
        {activeTab === 'Events' && <div className="p-4">
          <div className='flex justify-between'>
            <div><img className='w-[520px] h-[520px] object-cover rounded-lg shadow-lg shadow-pink-200' src={pic1} alt="" onClick={() => openLightbox(eventImages, 0)} style={{cursor:'pointer'}} /></div>
            <div>
              <div className='flex'>
                <img className='w-[252px] h-[248px] object-cover rounded-lg shadow-lg shadow-pink-200' src={pic2} alt="" onClick={() => openLightbox(eventImages, 1)} style={{cursor:'pointer'}} />
                <img className='w-[252px] h-[248px] ml-4 object-cover rounded-lg shadow-lg shadow-pink-200' src={pic3} alt="" onClick={() => openLightbox(eventImages, 2)} style={{cursor:'pointer'}} />
              </div>
              <div className='flex'>
                <img className='w-[252px] h-[248px] mt-4 object-cover rounded-lg shadow-lg shadow-pink-200' src={pic4} alt="" onClick={() => openLightbox(eventImages, 3)} style={{cursor:'pointer'}} />
                <img className='w-[252px] h-[248px] ml-4 mt-4 object-cover rounded-lg shadow-lg shadow-pink-200' src={pic5} alt="" onClick={() => openLightbox(eventImages, 4)} style={{cursor:'pointer'}} />
              </div>
            </div>
          </div>
          <div className='flex justify-between mt-4'>
            <div>
              <div className='flex'>
                <img className='w-[252px] h-[248px] object-cover rounded-lg shadow-lg shadow-pink-200' src={pic13} alt="" onClick={() => openLightbox(eventImages, 5)} style={{cursor:'pointer'}} />
                <img className='w-[252px] h-[248px] ml-4 object-cover rounded-lg shadow-lg shadow-pink-200' src={pic7} alt="" onClick={() => openLightbox(eventImages, 6)} style={{cursor:'pointer'}} />
              </div>
              <div className='flex'>
                <img className='w-[252px] h-[248px] mt-4 object-cover rounded-lg shadow-lg shadow-pink-200' src={pic8} alt="" onClick={() => openLightbox(eventImages, 7)} style={{cursor:'pointer'}} />
                <img className='w-[252px] h-[248px] ml-4 mt-4 object-cover rounded-lg shadow-lg shadow-pink-200' src={pic9} alt="" onClick={() => openLightbox(eventImages, 8)} style={{cursor:'pointer'}} />
              </div>
            </div>
            <div><img className='w-[520px] h-[513px] object-cover rounded-lg shadow-lg shadow-pink-200' src={pic18} alt="" onClick={() => openLightbox(eventImages, 9)} style={{cursor:'pointer'}} /></div>
          </div>
          {/* New photos */}
          <div className='flex justify-between mt-4'>
            <img className='w-[252px] h-[248px] object-cover rounded-lg shadow-lg shadow-pink-200' src={newPhoto1} alt="" onClick={() => openLightbox(eventImages, 10)} style={{cursor:'pointer'}} />
            <img className='w-[252px] h-[248px] object-cover rounded-lg shadow-lg shadow-pink-200' src={newPhoto2} alt="" onClick={() => openLightbox(eventImages, 11)} style={{cursor:'pointer'}} />
            <img className='w-[252px] h-[248px] object-cover rounded-lg shadow-lg shadow-pink-200' src={newPhoto3} alt="" onClick={() => openLightbox(eventImages, 12)} style={{cursor:'pointer'}} />
            <img className='w-[252px] h-[248px] object-cover rounded-lg shadow-lg shadow-pink-200' src={newPhoto4} alt="" onClick={() => openLightbox(eventImages, 13)} style={{cursor:'pointer'}} />
          </div>
        </div>}

        {/* CLASSES */}
        {activeTab === 'Classes' && <div className="p-4">
          <div className='flex justify-between'>
            <div><img className='w-[520px] h-[520px] object-cover rounded-lg shadow-lg shadow-pink-200' src={pic10} alt="" onClick={() => openLightbox(classImages, 0)} style={{cursor:'pointer'}} /></div>
            <div>
              <div className='flex'>
                <img className='w-[252px] h-[248px] object-cover rounded-lg shadow-lg shadow-pink-200' src={pic9} alt="" onClick={() => openLightbox(classImages, 1)} style={{cursor:'pointer'}} />
                <img className='w-[252px] h-[248px] ml-4 object-cover rounded-lg shadow-lg shadow-pink-200' src={pic8} alt="" onClick={() => openLightbox(classImages, 2)} style={{cursor:'pointer'}} />
              </div>
              <div className='flex'>
                <img className='w-[252px] h-[248px] mt-4 object-cover rounded-lg shadow-lg shadow-pink-200' src={pic12} alt="" onClick={() => openLightbox(classImages, 3)} style={{cursor:'pointer'}} />
                <img className='w-[252px] h-[248px] ml-4 mt-4 object-cover rounded-lg shadow-lg shadow-pink-200' src={pic19} alt="" onClick={() => openLightbox(classImages, 4)} style={{cursor:'pointer'}} />
              </div>
            </div>
          </div>
          <div className='flex justify-between mt-4'>
            <div>
              <div className='flex'>
                <img className='w-[252px] h-[248px] object-cover rounded-lg shadow-lg shadow-pink-200' src={pic5} alt="" onClick={() => openLightbox(classImages, 5)} style={{cursor:'pointer'}} />
                <img className='w-[252px] h-[248px] ml-4 object-cover rounded-lg shadow-lg shadow-pink-200' src={pic4} alt="" onClick={() => openLightbox(classImages, 6)} style={{cursor:'pointer'}} />
              </div>
              <div className='flex'>
                <img className='w-[252px] h-[248px] mt-4 object-cover rounded-lg shadow-lg shadow-pink-200' src={pic3} alt="" onClick={() => openLightbox(classImages, 7)} style={{cursor:'pointer'}} />
                <img className='w-[252px] h-[248px] ml-4 mt-4 object-cover rounded-lg shadow-lg shadow-pink-200' src={pic20} alt="" onClick={() => openLightbox(classImages, 8)} style={{cursor:'pointer'}} />
              </div>
            </div>
            <div><img className='w-[520px] h-[513px] object-cover rounded-lg shadow-lg shadow-pink-200' src={pic13} alt="" onClick={() => openLightbox(classImages, 9)} style={{cursor:'pointer'}} /></div>
          </div>
          {/* New photos */}
          <div className='flex justify-between mt-4'>
            <img className='w-[252px] h-[248px] object-cover rounded-lg shadow-lg shadow-pink-200' src={newPhoto5} alt="" onClick={() => openLightbox(classImages, 10)} style={{cursor:'pointer'}} />
            <img className='w-[252px] h-[248px] object-cover rounded-lg shadow-lg shadow-pink-200' src={newPhoto6} alt="" onClick={() => openLightbox(classImages, 11)} style={{cursor:'pointer'}} />
            <img className='w-[252px] h-[248px] object-cover rounded-lg shadow-lg shadow-pink-200' src={newPhoto7} alt="" onClick={() => openLightbox(classImages, 12)} style={{cursor:'pointer'}} />
            <img className='w-[252px] h-[248px] object-cover rounded-lg shadow-lg shadow-pink-200' src={newPhoto8} alt="" onClick={() => openLightbox(classImages, 13)} style={{cursor:'pointer'}} />
          </div>
        </div>}

        {/* TEAM */}
        {activeTab === 'Team' && <div className="p-4">
          <div className='flex justify-between'>
            <div><img className='w-[520px] h-[520px] object-cover rounded-lg shadow-lg shadow-pink-200' src={team6} alt="" onClick={() => openLightbox(teamImages, 0)} style={{cursor:'pointer'}} /></div>
            <div>
              <div className='flex'>
                <img className='w-[252px] h-[248px] object-cover rounded-lg shadow-lg shadow-pink-200' src={team2} alt="" onClick={() => openLightbox(teamImages, 1)} style={{cursor:'pointer'}} />
                <img className='w-[252px] h-[248px] ml-4 object-cover rounded-lg shadow-lg shadow-pink-200' src={team3} alt="" onClick={() => openLightbox(teamImages, 2)} style={{cursor:'pointer'}} />
              </div>
              <div className='flex'>
                <img className='w-[252px] h-[248px] mt-4 object-cover rounded-lg shadow-lg shadow-pink-200' src={team4} alt="" onClick={() => openLightbox(teamImages, 3)} style={{cursor:'pointer'}} />
                <img className='w-[252px] h-[248px] ml-4 mt-4 object-cover rounded-lg shadow-lg shadow-pink-200' src={team5} alt="" onClick={() => openLightbox(teamImages, 4)} style={{cursor:'pointer'}} />
              </div>
            </div>
          </div>
          <div className='flex justify-between mt-4'>
            <div>
              <div className='flex'>
                <img className='w-[252px] h-[248px] object-cover rounded-lg shadow-lg shadow-pink-200' src={team1} alt="" onClick={() => openLightbox(teamImages, 5)} style={{cursor:'pointer'}} />
                <img className='w-[252px] h-[248px] ml-4 object-cover rounded-lg shadow-lg shadow-pink-200' src={team7} alt="" onClick={() => openLightbox(teamImages, 6)} style={{cursor:'pointer'}} />
              </div>
              <div className='flex'>
                <img className='w-[252px] h-[248px] mt-4 object-cover rounded-lg shadow-lg shadow-pink-200' src={team8} alt="" onClick={() => openLightbox(teamImages, 7)} style={{cursor:'pointer'}} />
                <img className='w-[252px] h-[248px] ml-4 mt-4 object-cover rounded-lg shadow-lg shadow-pink-200' src={team9} alt="" onClick={() => openLightbox(teamImages, 8)} style={{cursor:'pointer'}} />
              </div>
            </div>
            <div><img className='w-[520px] h-[513px] object-cover rounded-lg shadow-lg shadow-pink-200' src={team10} alt="" onClick={() => openLightbox(teamImages, 9)} style={{cursor:'pointer'}} /></div>
          </div>
          {/* New photos */}
          <div className='flex justify-between mt-4'>
            <img className='w-[252px] h-[248px] object-cover rounded-lg shadow-lg shadow-pink-200' src={newPhoto9} alt="" onClick={() => openLightbox(teamImages, 10)} style={{cursor:'pointer'}} />
            <img className='w-[252px] h-[248px] object-cover rounded-lg shadow-lg shadow-pink-200' src={newPhoto10} alt="" onClick={() => openLightbox(teamImages, 11)} style={{cursor:'pointer'}} />
            <img className='w-[252px] h-[248px] object-cover rounded-lg shadow-lg shadow-pink-200' src={newPhoto11} alt="" onClick={() => openLightbox(teamImages, 12)} style={{cursor:'pointer'}} />
            <img className='w-[252px] h-[248px] object-cover rounded-lg shadow-lg shadow-pink-200' src={newPhoto12} alt="" onClick={() => openLightbox(teamImages, 13)} style={{cursor:'pointer'}} />
          </div>
        </div>}

        {/* SUMMER CAMP */}
        {activeTab === 'Summer Camp' && <div className="p-4 text-left">
          {summerCampAlbums.map((album) => (
            <div key={album.year} className='mb-14'>
              <h3 className='text-[28px] font-bold text-gray-900 mb-2' style={{ fontFamily: "'Playfair Display', serif" }}>
                Summer Camp <em style={{ color: '#E40F94' }}>{album.year}</em>
              </h3>
              <div className='w-10 h-[3px] bg-[#E40F94] rounded-full mb-6'></div>
              <div className='grid grid-cols-3 gap-4'>
                {album.images.map((img, idx) => (
                  <img key={idx} className='w-full h-[260px] object-cover rounded-lg shadow-lg shadow-pink-200 cursor-pointer' src={img} alt={`Summer Camp ${album.year} – ${idx + 1}`} loading='lazy' onClick={() => openLightbox(album.images, idx)} />
                ))}
              </div>
            </div>
          ))}
        </div>}

      </div>

      {/* Mobile Tabs */}
      <div className="flex justify-center md:mt-16 mt-6 md:hidden block">
        <div className={`px-4 py-2 cursor-pointer text-sm ${activeTab1 === "Album 1" ? "border-b-2 border-pink-500 text-pink-500" : ""}`} onClick={() => setActiveTab1("Album 1")}>Events</div>
        <div className={`px-4 py-2 cursor-pointer text-sm ${activeTab1 === "Album 2" ? "border-b-2 border-pink-500 text-pink-500" : ""}`} onClick={() => setActiveTab1("Album 2")}>Classes</div>
        <div className={`px-4 py-2 cursor-pointer text-sm ${activeTab1 === "Album 3" ? "border-b-2 border-pink-500 text-pink-500" : ""}`} onClick={() => setActiveTab1("Album 3")}>Team</div>
        <div className={`px-4 py-2 cursor-pointer text-sm ${activeTab1 === "Album 4" ? "border-b-2 border-pink-500 text-pink-500" : ""}`} onClick={() => setActiveTab1("Album 4")}>Summer Camp</div>
      </div>

      {/* Mobile Summer Camp albums */}
      {activeTab1 === "Album 4" && (
        <div className="md:hidden mt-6">
          {summerCampAlbums.map((album) => (
            <div key={album.year} className="mb-10">
              <h3 className="text-[22px] font-bold text-gray-900 mb-3" style={{ fontFamily: "'Playfair Display', serif" }}>
                Summer Camp <em style={{ color: '#E40F94' }}>{album.year}</em>
              </h3>
              <div className="grid grid-cols-2 gap-3">
                {album.images.map((img, idx) => (
                  <img key={idx} src={img} className="w-full h-[150px] object-cover rounded-lg" alt={`Summer Camp ${album.year} – ${idx + 1}`} loading="lazy" onClick={() => openLightbox(album.images, idx)} />
                ))}
              </div>
            </div>
          ))}
        </div>
      )}

      {/* Mobile Carousel */}
      {activeTab1 !== "Album 4" && <div className="md:hidden mt-6">
        <Slider {...sliderSettings}>
          {(activeTab1 === "Album 1" ? eventImages : activeTab1 === "Album 2" ? classImages : teamImages).map((img, index) => (
            <div key={index} className="p-2">
              <img src={img} className="w-full rounded-lg" alt={`Photo ${index + 1}`} />
            </div>
          ))}
        </Slider>
      </div>}

    </div>
  );
}

export default GalleryComponent;
